import type { RiskClass } from '@ralph/contracts'

/**
 * The connected-systems numbers and orderings, which are not copy.
 *
 * They lived inside `systems-strings.ts` until the catalogue became locale-keyed, and that
 * is precisely why they had to leave it (PRD-27 F-20, D-25, LOC-017): a pt-BR file copied
 * from the English one and then edited would change `NAME_MAX` **for Portuguese users
 * only** — a validation limit that differs by language is a bug with no symptom until
 * somebody's system name is refused in one tab and accepted in another.
 *
 * `RISK_ORDER` is the same kind of thing for a different reason. It is the reading order of
 * the class selector — least to most consequential — and that order is an argument about
 * risk, not a sentence. It is identical in every language.
 */

/** A connected system's short name, which also becomes part of this page's address. */
export const NAME_MAX = 31

/** The administrator's own description of a system. */
export const DESCRIPTION_MAX = 300

/**
 * Least consequential first, so the menu reads as a ladder rather than as a set.
 *
 * `read` is the only class that provably changes nothing; `destructive` is the only one that
 * cannot be undone. Everything between them is ordered by how much of the world moves.
 */
export const RISK_ORDER: RiskClass[] = [
  'read',
  'reversible_write',
  'external_communication',
  'privileged',
  'financial',
  'destructive'
]
